import React from 'react';
import {
  Button,
  DatePicker,
  IconButton,
  LinearGradient,
  NumberInput,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { ActivityIndicator, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as AdditionalCategory from '../custom-files/AdditionalCategory';
import addOrRemove from '../global-functions/addOrRemove';
import calculateCashOnHandFlow from '../global-functions/calculateCashOnHandFlow';
import cashOnHand from '../global-functions/cashOnHand';
import checkScreenMode from '../global-functions/checkScreenMode';
import createStartingBalance from '../global-functions/createStartingBalance';
import customCategory from '../global-functions/customCategory';
import findColumnRowNumber from '../global-functions/findColumnRowNumber';
import findIndextAllCategories from '../global-functions/findIndextAllCategories';
import formatNumber from '../global-functions/formatNumber';
import formatPercentage from '../global-functions/formatPercentage';
import generateDates from '../global-functions/generateDates';
import getCurrentYear from '../global-functions/getCurrentYear';
import getInitValue from '../global-functions/getInitValue';
import initTableRows from '../global-functions/initTableRows';
import mergeCategoriesNumbers from '../global-functions/mergeCategoriesNumbers';
import newFormatDate from '../global-functions/newFormatDate';
import prefillNumberInputs from '../global-functions/prefillNumberInputs';
import removeFromCategories from '../global-functions/removeFromCategories';
import removeFromNumberInputs from '../global-functions/removeFromNumberInputs';
import sortCategories from '../global-functions/sortCategories';
import sumArrays from '../global-functions/sumArrays';
import timestampToISO from '../global-functions/timestampToISO';
import updateTableRows from '../global-functions/updateTableRows';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { get: null };

const IncomeFormScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [additionalCategory, setAdditionalCategory] = React.useState([]);
  const [allCategories, setAllCategories] = React.useState([]);
  const [balanceAlert, setBalanceAlert] = React.useState(0);
  const [endingBalance, setEndingBalance] = React.useState([]);
  const [incomeData, setIncomeData] = React.useState([]);
  const [isFetching, setIsFetching] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(true);
  const [monthlyStartingBalance, setMonthlyStartingBalance] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [newCategory, setNewCategory] = React.useState('');
  const [numberInputs, setNumberInputs] = React.useState([]);
  const [onFocusAlert, setOnFocusAlert] = React.useState(false);
  const [onFocusStartingCash, setOnFocusStartingCash] = React.useState(false);
  const [previousMonthValue, setPreviousMonthValue] = React.useState('');
  const [reFetch, setReFetch] = React.useState(false);
  const [reRender, setReRender] = React.useState(false);
  const [selectedIndexes, setSelectedIndexes] = React.useState([]);
  const [startingCashOn, setStartingCashOn] = React.useState(0);
  const [startingDate, setStartingDate] = React.useState('');
  const [toggleAddCategory, setToggleAddCategory] = React.useState(false);
  const [toggleNewCategory, setToggleNewCategory] = React.useState(false);
  const [totalCashAvailablePerMonth, setTotalCashAvailablePerMonth] =
    React.useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [totalIncomePerCategories, setTotalIncomePerCategories] =
    React.useState([0, 0, 0, 0, 0, 0, 0, 0]);
  const [totalIncomePerMonth, setTotalIncomePerMonth] = React.useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [trigger, setTrigger] = React.useState(false);
  const [usersCategories, setUsersCategories] = React.useState([]);
  const addNewRow = matrix => {
    const newRow = new Array(matrix[0].length).fill(0);

    matrix.push(newRow);

    return matrix;
  };

  const calculateBenchmark = arr => {
    const total = arr.reduce((acc, num) => acc + num, 0);

    const percentageArray = arr.map(num => (num / total) * 100);

    return percentageArray;
  };

  const cellWidth = () => {
    const windowWidth = window.innerWidth;
    const result = (windowWidth - windowWidth * 0.15 - 600) / 14;
    return result;
  };

  const getMonthlyExpenses = (totalExpense, startingDate) => {
    if (!totalExpense || totalExpense.length === 0) {
      return Array(12).fill(0);
    }

    const result = [];
    const startDate = new Date(startingDate);
    const startYear = startDate.getUTCFullYear();
    const startMonth = startDate.getUTCMonth();

    let currentYear = startYear;
    let currentMonth = startMonth;
    let expenseIndex = 0;

    for (let i = 0; i < 12; i++) {
      if (expenseIndex < totalExpense.length) {
        const expenseDate = new Date(
          totalExpense[expenseIndex].monthly_expenses_month
        );
        const expenseYear = expenseDate.getUTCFullYear();
        const expenseMonth = expenseDate.getUTCMonth();

        if (expenseYear === currentYear && expenseMonth === currentMonth) {
          result.push(totalExpense[expenseIndex].monthly_expenses_amount);
          expenseIndex++;
        } else {
          result.push(0);
        }
      } else {
        result.push(0);
      }

      currentMonth++;
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
    }

    return result;
  };

  const newTimestampConverter = timestamp => {
    console.log('timestamp', timestamp);
    const date = new Date(timestamp);
    console.log('date', date);
    // Get the date in ISO format and ensure it's in UTC
    const utcDateString = date.toISOString();
    console.log('return', utcDateString);
    return utcDateString;
  };

  const pullStartingBalance = (data, startingDate, income, expense) => {
    // const result = []
    // console.log("selected month:",startingDate)
    // let currentDate = new Date(startingDate);
    // currentDate.setUTCDate(1)

    // for (let i = 0; i < 12; i++) {
    //     const matchingRecord = data.find(record => {
    //         const recordDate = new Date(record.month);
    //         return recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
    //             recordDate.getUTCMonth() === currentDate.getUTCMonth();
    //     });

    //     if (matchingRecord) {
    //         result.push(matchingRecord.amount)
    //     } else {
    //         result.push(0)
    //     }

    //     currentDate.setUTCMonth(currentDate.getUTCMonth() + 1)
    // }

    // return result

    //making changes for next month if we dont have any record for starting balance
    //console.log("data", data)
    //console.log("income:", income)
    //console.log("expense:", expense)

    const result = [];

    let currentDate = new Date(startingDate);
    currentDate.setUTCDate(1);

    let lastValue = 0; // İlk başta son değer 0 olarak başlar

    for (let i = 0; i < 12; i++) {
      const matchingRecord = data.find(record => {
        const recordDate = new Date(record.month);
        return (
          recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
          recordDate.getUTCMonth() === currentDate.getUTCMonth()
        );
      });

      if (matchingRecord) {
        lastValue = matchingRecord.amount; // Son değeri güncelle
        result.push(lastValue);
      } else {
        if (currentDate < new Date()) {
          // Geçmiş bir tarih için kayıt yoksa 0 ekle
          result.push(0);
          lastValue = 0; // Son değeri sıfır olarak güncelle
        } else {
          // Gelecek bir tarih için hesaplama yap
          const incomeIndex = (i - 1 + income.length) % income.length; // Bir önceki ayın income indexi
          const expenseIndex = (i - 1 + expense.length) % expense.length; // Bir önceki ayın expense indexi

          const incomeValue = income[incomeIndex] || 0;
          const expenseValue = expense[expenseIndex] || 0;

          const newValue = lastValue + incomeValue - expenseValue;
          result.push(newValue);
          lastValue = newValue; // Son değeri güncelle
        }
      }

      currentDate.setUTCMonth(currentDate.getUTCMonth() + 1); // Ayı bir ileri al
    }

    //console.log("final result:", result)
    return result;
  };

  const totalForCategory = arrays => {
    let result = [];

    for (let i = 0; i < arrays.length; i++) {
      let sum = 0;
      for (let j = 0; j < arrays[i].length; j++) {
        sum += arrays[i][j];
      }
      result.push(sum);
    }

    return result;
  };

  const totalForMonth = arrays => {
    const length = arrays[0].length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < arrays.length; j++) {
        result[i] += arrays[j][i];
      }
    }

    let totalSum = result.reduce((acc, val) => acc + val, 0);

    result.push(totalSum);

    return result;
  };

  const updateStartingBalance = (array, oldValue, newValue) => {
    // const updatedArray = []
    // let currentSum = value

    // for (let i = 0; i < array.length; i++) {
    //     if (i === 0) {
    //         updatedArray.push(currentSum)
    //     } else {
    //         currentSum += array[i]
    //         updatedArray.push(currentSum)
    //     }
    // }

    // return updatedArray

    const difference = newValue - oldValue;
    return array.map(num => num + difference);
  };

  const updateStartingBalanceWithIncomeChange = (
    startingBalance,
    oldIncome,
    newIncome
  ) => {
    const updatedStartingBalance = [...startingBalance];

    for (let i = 0; i < oldIncome.length; i++) {
      const difference = newIncome[i] - oldIncome[i];
      if (difference !== 0) {
        for (let j = i + 1; j < updatedStartingBalance.length; j++) {
          updatedStartingBalance[j] += difference;
        }
        break;
      }
    }

    return updatedStartingBalance;
  };
  const defaultNewMonthsValuesPOST = DefaultApi.useNewMonthsValuesPOST();
  const defaultPostIncomesPOST = DefaultApi.usePostIncomesPOST();
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }
      if (startingDate) {
      } else {
        const value3M8oPakl = timestampToISO(Constants['STARTING_DATE']);
        const test = value3M8oPakl;
        setStartingDate(value3M8oPakl);
        setIsFetching(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={true}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
                maxHeight: {
                  minWidth: Breakpoints.Laptop,
                  value: dimensions.height,
                },
              },
              dimensions.width
            )}
          >
            <SideMenuBlock
              screen={'income'}
              setTrigger={trigger => setTrigger(trigger)}
              trigger={trigger}
            />
            {/* Income Form View */}
            <View
              style={StyleSheet.applyWidth(
                {
                  flex: { minWidth: Breakpoints.Laptop, value: 1 },
                  gap: { minWidth: Breakpoints.Laptop, value: 100 },
                },
                dimensions.width
              )}
            >
              {/* Header */}
              <View>
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)[
                    'Header Linear Gradient'
                  ].props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.LinearGradientStyles(theme)[
                        'Header Linear Gradient'
                      ].style,
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {/* Left */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        paddingLeft: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  />
                  {/* Middle */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 4 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Header'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 22,
                            },
                            paddingBottom: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                            paddingTop: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Beginning Balance and Forecasted Income'}
                    </Text>
                  </View>
                  {/* Right */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          navigation.navigate('BestPracticesScreen');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      color={palettes.Brand.White}
                      icon={'Entypo/help-with-circle'}
                      size={24}
                    />
                  </View>
                </LinearGradient>
              </View>
              {/* Loading View 2 */}
              <>
                {!(isLoading || isFetching) ? null : (
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['Black %50'],
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        gap: { minWidth: Breakpoints.Laptop, value: 20 },
                        height: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.height,
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        position: {
                          minWidth: Breakpoints.Laptop,
                          value: 'absolute',
                        },
                        width: [
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              dimensions.width - dimensions.width * (20 / 100),
                          },
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              dimensions.width - dimensions.width * (15 / 100),
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  >
                    <ActivityIndicator
                      animating={true}
                      hidesWhenStopped={true}
                      {...GlobalStyles.ActivityIndicatorStyles(theme)[
                        'Activity Indicator'
                      ].props}
                      size={'large'}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.ActivityIndicatorStyles(theme)[
                          'Activity Indicator'
                        ].style,
                        dimensions.width
                      )}
                    />
                    {/* Message */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Header'].style,
                        dimensions.width
                      )}
                    >
                      {'Loading, please wait...'}
                    </Text>
                  </View>
                )}
              </>
              <>
                {isFetching ? null : (
                  <DefaultApi.FetchGetIncomeHeadsGET
                    handlers={{
                      onData: fetchData => {
                        const handler = async () => {
                          try {
                            if (reFetch) {
                              return;
                            }
                            setIsLoading(true);
                            setSelectedIndexes([]);

                            const valueiZoThRUG = sortCategories(
                              (fetchData?.income_heads).concat(
                                fetchData?.custom_income_heads
                              )
                            );
                            const userCategoriesRes = valueiZoThRUG;
                            setUsersCategories(valueiZoThRUG);
                            const all_categories = (
                              await DefaultApi.allIncomeHeadsGET(Constants)
                            )?.json;
                            setAllCategories(all_categories);
                            const resIncome = (
                              await DefaultApi.getIncomeGET(Constants, {
                                starting_date: newFormatDate(
                                  startingDate,
                                  'get'
                                ),
                              })
                            )?.json;
                            const total_cash_paid = setGlobalVariableValue({
                              key: 'TOTAL_CASH_PAID',
                              value: getMonthlyExpenses(
                                resIncome?.total_expenses,
                                startingDate
                              ),
                            });

                            const valuemIcxUEnI = [].concat(
                              (resIncome?.default).concat(resIncome?.custom)
                            );
                            const monthlyIncome = valuemIcxUEnI;
                            setIncomeData(valuemIcxUEnI);
                            if (
                              resIncome?.message ||
                              resIncome?.default?.length === 0
                            ) {
                              const initData = (() => {
                                if (numberInputs?.length === 0) {
                                  return initTableRows(
                                    fetchData?.income_heads?.length +
                                      fetchData?.custom_income_heads?.length,
                                    12
                                  );
                                }
                              })();
                              if (numberInputs?.length === 0) {
                                setNumberInputs(initData);
                              }
                            } else {
                              const valuePcbi1aZC =
                                resIncome?.previous_months_cash_on_hand;
                              const previous_month_value = valuePcbi1aZC;
                              setPreviousMonthValue(valuePcbi1aZC);
                              const valuesmOhCnDE = prefillNumberInputs(
                                monthlyIncome,
                                userCategoriesRes,
                                startingDate
                              );
                              const numberInputsRes = valuesmOhCnDE;
                              setNumberInputs(valuesmOhCnDE);
                              const valueJNQqQklk =
                                totalForMonth(numberInputsRes);
                              const total_income_per_month = valueJNQqQklk;
                              setTotalIncomePerMonth(valueJNQqQklk);
                              setTotalIncomePerCategories(
                                totalForCategory(numberInputsRes)
                              );
                              setBalanceAlert(
                                Constants['USER_DETAILS']?._profile_of_user
                                  ?.cash_min_balance
                              );

                              const valueujuikaY0 = pullStartingBalance(
                                resIncome?.cash_at_hand,
                                newFormatDate(startingDate, 'get'),
                                total_income_per_month,
                                total_cash_paid
                              );
                              const monthly_starting_balance2 = valueujuikaY0;
                              setMonthlyStartingBalance(valueujuikaY0);
                              const valueaoeeYF8l =
                                monthly_starting_balance2 &&
                                monthly_starting_balance2[0];
                              const startingCash = valueaoeeYF8l;
                              setStartingCashOn(valueaoeeYF8l);
                              /* hidden 'Set Variable' action */
                              setTotalCashAvailablePerMonth(
                                sumArrays(
                                  monthly_starting_balance2,
                                  total_income_per_month
                                )
                              );
                              /* hidden 'Set Variable' action */
                            }

                            setReFetch(true);
                            setIsLoading(false);
                          } catch (err) {
                            console.error(err);
                          }
                        };
                        handler();
                      },
                    }}
                  >
                    {({ loading, error, data, refetchGetIncomeHeads }) => {
                      const fetchData = data?.json;
                      if (loading) {
                        return (
                          <>
                            {/* Loading View */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 1,
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 20,
                                  },
                                  height: {
                                    minWidth: Breakpoints.Laptop,
                                    value: dimensions.height,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  position: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'absolute',
                                  },
                                  width: [
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value:
                                        dimensions.width -
                                        dimensions.width * (20 / 100),
                                    },
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value:
                                        dimensions.width -
                                        dimensions.width * (15 / 100),
                                    },
                                  ],
                                },
                                dimensions.width
                              )}
                            />
                          </>
                        );
                      }

                      if (error || data?.status < 200 || data?.status >= 300) {
                        return <ActivityIndicator />;
                      }

                      return (
                        <>
                          <>
                            {isLoading ? null : (
                              <SimpleStyleScrollView
                                bounces={true}
                                keyboardShouldPersistTaps={'never'}
                                nestedScrollEnabled={false}
                                showsHorizontalScrollIndicator={true}
                                showsVerticalScrollIndicator={true}
                                horizontal={true}
                              >
                                {/* Table */}
                                <View>
                                  {/* Header 1 */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 25,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Blank */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            maxWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: 300,
                                              },
                                            ],
                                            minWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: 300,
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    />
                                    {/* Month */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Month */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Month'}
                                      </Text>
                                    </LinearGradient>
                                    {/* Months List */}
                                    <SimpleStyleFlatList
                                      data={generateDates(
                                        newFormatDate(startingDate, 'get')
                                      )}
                                      decelerationRate={'normal'}
                                      inverted={false}
                                      keyExtractor={(monthsListData, index) =>
                                        monthsListData?.id ??
                                        monthsListData?.uuid ??
                                        index?.toString() ??
                                        JSON.stringify(monthsListData)
                                      }
                                      keyboardShouldPersistTaps={'never'}
                                      listKey={'YQ2rJkFH'}
                                      nestedScrollEnabled={false}
                                      numColumns={1}
                                      onEndReachedThreshold={0.5}
                                      pagingEnabled={false}
                                      renderItem={({ item, index }) => {
                                        const monthsListData = item;
                                        return (
                                          <>
                                            {/* Months Gradient */}
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: cellWidth(),
                                                      },
                                                    ],
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {/* Months Text */}
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {monthsListData}
                                              </Text>
                                            </LinearGradient>
                                          </>
                                        );
                                      }}
                                      showsVerticalScrollIndicator={true}
                                      snapToAlignment={'start'}
                                      horizontal={true}
                                      scrollEnabled={false}
                                      showsHorizontalScrollIndicator={false}
                                    />
                                    {/* % Of Income Gradient */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: cellWidth(),
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    ></LinearGradient>
                                    {/* Benchmarks */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: cellWidth(),
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    ></LinearGradient>
                                  </View>
                                  {/* Header 2 */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                        height: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 25,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Blank */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            maxWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: 300,
                                              },
                                            ],
                                            minWidth: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: 300,
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    />
                                    {/* Category/Ending Balance */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Category/Ending Balance */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Income Category/Starting Balance'}
                                      </Text>
                                    </LinearGradient>
                                    {/* Starting Balance */}
                                    <SimpleStyleFlatList
                                      data={monthlyStartingBalance}
                                      decelerationRate={'normal'}
                                      inverted={false}
                                      keyExtractor={(
                                        startingBalanceData,
                                        index
                                      ) =>
                                        startingBalanceData?.id ??
                                        startingBalanceData?.uuid ??
                                        index?.toString() ??
                                        JSON.stringify(startingBalanceData)
                                      }
                                      keyboardShouldPersistTaps={'never'}
                                      listKey={'7gT9bEri'}
                                      nestedScrollEnabled={false}
                                      numColumns={1}
                                      onEndReachedThreshold={0.5}
                                      pagingEnabled={false}
                                      renderItem={({ item, index }) => {
                                        const startingBalanceData = item;
                                        return (
                                          <>
                                            {/* Ending Balance */}
                                            <LinearGradient
                                              endY={100}
                                              startX={0}
                                              startY={0}
                                              {...GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].props}
                                              color1={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              color2={
                                                palettes.App['App Blue Light']
                                              }
                                              color3={
                                                palettes.Brand['App Blue Dark']
                                              }
                                              endX={0}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].style,
                                                  {
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    borderColor: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value:
                                                        palettes.Brand.White,
                                                    },
                                                    borderLeftWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: cellWidth(),
                                                      },
                                                    ],
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {'$ '}
                                                {formatNumber(
                                                  startingBalanceData
                                                )}
                                              </Text>
                                            </LinearGradient>
                                          </>
                                        );
                                      }}
                                      showsVerticalScrollIndicator={true}
                                      snapToAlignment={'start'}
                                      extraData={reRender}
                                      horizontal={true}
                                      showsHorizontalScrollIndicator={false}
                                    />
                                    {/* Total Gradient */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: [
                                              {
                                                minWidth: Breakpoints.Laptop,
                                                value: 75,
                                              },
                                              {
                                                minWidth: Breakpoints.BigScreen,
                                                value: cellWidth(),
                                              },
                                            ],
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* Total Text */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Total'}
                                      </Text>
                                    </LinearGradient>
                                    {/* % Income Gradient */}
                                    <LinearGradient
                                      endY={100}
                                      startX={0}
                                      startY={0}
                                      {...GlobalStyles.LinearGradientStyles(
                                        theme
                                      )['Blue Linear'].props}
                                      color1={palettes.Brand['App Blue Dark']}
                                      color2={palettes.App['App Blue Light']}
                                      color3={palettes.Brand['App Blue Dark']}
                                      endX={0}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].style,
                                          {
                                            borderBottomWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.White,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 75,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {/* % Income */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Chart Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].style,
                                          dimensions.width
                                        )}
                                      >
                                        {'% Income'}
                                      </Text>
                                    </LinearGradient>
                                  </View>
                                  {/* Table Main */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flexDirection: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'row',
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Left */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          flexDirection: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'column',
                                          },
                                          width: [
                                            {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                            {
                                              minWidth: Breakpoints.BigScreen,
                                              value: 300,
                                            },
                                          ],
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      <LinearGradient
                                        color1={
                                          Constants['SWITCH_SCREEN_MODE'] ===
                                          false
                                            ? palettes.App[
                                                'Corner Gradient Dark'
                                              ]
                                            : palettes.Brand.White
                                        }
                                        color2={
                                          Constants['SWITCH_SCREEN_MODE'] ===
                                          false
                                            ? palettes.App[
                                                'Corner Gradient Light'
                                              ]
                                            : palettes.Brand.White
                                        }
                                        color3={
                                          Constants['SWITCH_SCREEN_MODE'] ===
                                          false
                                            ? palettes.App[
                                                'Corner Gradient Dark'
                                              ]
                                            : palettes.Brand.White
                                        }
                                        endX={0}
                                        endY={100}
                                        startX={50}
                                        startY={50}
                                        style={StyleSheet.applyWidth(
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'stretch',
                                            },
                                            borderRightWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            gap: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 24,
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                            justifyContent: {
                                              minWidth: Breakpoints.Laptop,
                                              value: null,
                                            },
                                            maxHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: null,
                                            },
                                            maxWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: null,
                                            },
                                            minHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: null,
                                            },
                                            minWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: null,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Starting Date Cell */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 26,
                                              },
                                              marginTop: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 24,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                alignItems: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-end',
                                                },
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 0,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.Black,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            {/* Starting Date Text */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text White'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text White'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Starting date'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Inner Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            color1={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            color2={
                                              checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]
                                            }
                                            color3={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 0,
                                                },
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            <DatePicker
                                              autoDismissKeyboard={true}
                                              disabled={false}
                                              hideLabel={false}
                                              inline={false}
                                              leftIconMode={'inset'}
                                              mode={'date'}
                                              onDateChange={newDatePickerValue => {
                                                const handler = async () => {
                                                  try {
                                                    setStartingDate(
                                                      newDatePickerValue
                                                    );
                                                    setIsLoading(true);
                                                    setIsFetching(true);
                                                    const resIncome = (
                                                      await defaultNewMonthsValuesPOST.mutateAsync(
                                                        {
                                                          current_starting_date:
                                                            newFormatDate(
                                                              startingDate,
                                                              'get'
                                                            ),
                                                          new_starting_date:
                                                            newFormatDate(
                                                              newDatePickerValue,
                                                              'get'
                                                            ),
                                                        }
                                                      )
                                                    )?.json;
                                                    setStartingDate(
                                                      newDatePickerValue
                                                    );
                                                    setReFetch(false);
                                                    setIsFetching(false);
                                                  } catch (err) {
                                                    console.error(err);
                                                  }
                                                };
                                                handler();
                                              }}
                                              {...GlobalStyles.DatePickerStyles(
                                                theme
                                              )['Date Picker'].props}
                                              assistiveText={''}
                                              date={startingDate}
                                              format={'mmm-yy'}
                                              hideLabel={StyleSheet.getWidthValue(
                                                [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: true,
                                                  },
                                                ],
                                                dimensions.width
                                              )}
                                              label={''}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.DatePickerStyles(
                                                    theme
                                                  )['Date Picker'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    maxHeight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 23,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                              type={'solid'}
                                            />
                                          </LinearGradient>
                                        </View>
                                        {/* Starting cash on hand Cell */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Linear Gradient'].props}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Linear Gradient'].style,
                                                {
                                                  alignItems: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  borderBottomWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 0,
                                                  },
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.Black,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {/* Starting cash on hand Text */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text White'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text White'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Starting cash on hand'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Inner Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            color1={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            color2={
                                              checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]
                                            }
                                            color3={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                borderTopWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 0,
                                                },
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-end',
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            <NumberInput
                                              changeTextDelay={500}
                                              onBlur={() => {
                                                try {
                                                  setOnFocusStartingCash(false);
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              onChangeText={newNumberInputValue => {
                                                try {
                                                  setStartingCashOn(
                                                    newNumberInputValue
                                                  );
                                                  /* hidden 'Set Variable' action */
                                                  /* hidden 'Set Variable' action */

                                                  const valuegKHW6KL3 =
                                                    updateStartingBalance(
                                                      monthlyStartingBalance,
                                                      startingCashOn,
                                                      newNumberInputValue
                                                    );
                                                  const new_monthly =
                                                    valuegKHW6KL3;
                                                  setMonthlyStartingBalance(
                                                    valuegKHW6KL3
                                                  );
                                                  setTotalCashAvailablePerMonth(
                                                    sumArrays(
                                                      new_monthly,
                                                      totalIncomePerMonth
                                                    )
                                                  );
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              onFocus={() => {
                                                try {
                                                  setOnFocusStartingCash(true);
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              webShowOutline={true}
                                              {...GlobalStyles.NumberInputStyles(
                                                theme
                                              )['Table Number Input'].props}
                                              placeholder={''}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.NumberInputStyles(
                                                    theme
                                                  )['Table Number Input'].style,
                                                  {
                                                    color: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          'rgba(0, 0, 0, 0)',
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          onFocusStartingCash
                                                            ? Constants[
                                                                'SWITCH_SCREEN_MODE'
                                                              ]
                                                              ? palettes.Brand
                                                                  .Black
                                                              : palettes.Brand
                                                                  .White
                                                            : palettes.Brand
                                                                .Transparent,
                                                      },
                                                    ],
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 18,
                                                    },
                                                    textAlign: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'right',
                                                    },
                                                    zIndex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                              value={startingCashOn}
                                            />
                                            {/* Format View */}
                                            <>
                                              {onFocusStartingCash ? null : (
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 18,
                                                      },
                                                      position: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'absolute',
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                      zIndex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Format Text */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Text'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Text'].style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ]
                                                              ? palettes.Brand
                                                                  .Black
                                                              : palettes.Brand
                                                                  .White,
                                                          },
                                                          fontFamily: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              'OpenSans_600SemiBold',
                                                          },
                                                          fontSize: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 10,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {'$ '}
                                                    {formatNumber(
                                                      startingCashOn
                                                    )}
                                                  </Text>
                                                </View>
                                              )}
                                            </>
                                          </LinearGradient>
                                        </View>
                                        {/* Cash minimum balance alert */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderBottomWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              borderTopWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 26,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Linear Gradient'].props}
                                            color1={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]) ??
                                              palettes.App['Gray Linear Light']
                                            }
                                            color2={
                                              (checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]) ??
                                              palettes.App['Gray Linear Dark']
                                            }
                                            endX={0}
                                            startX={0}
                                            startY={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Linear Gradient'].style,
                                                {
                                                  alignItems: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  borderBottomWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 0,
                                                  },
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.Black,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {/* Cash minimum balance alert */}
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text White'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text White'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.Brand.White
                                                        : palettes.Brand.Black,
                                                    },
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Cash minimum balance alert'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Inner Gradient */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            color1={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            color2={
                                              checkScreenMode(Variables)
                                                ? palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                : palettes.App[
                                                    'Light Linear - Light'
                                                  ]
                                            }
                                            color3={
                                              checkScreenMode(Variables)
                                                ? palettes.Brand.Background
                                                : palettes.App[
                                                    'Light Linear - Dark'
                                                  ]
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                height: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-end',
                                                },
                                                maxHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minHeight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                                width: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: null,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          >
                                            <NumberInput
                                              changeTextDelay={500}
                                              onBlur={() => {
                                                try {
                                                  setOnFocusAlert(false);
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              onChangeText={newNumberInputValue => {
                                                try {
                                                  setBalanceAlert(
                                                    newNumberInputValue
                                                  );
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              onFocus={() => {
                                                try {
                                                  setOnFocusAlert(true);
                                                } catch (err) {
                                                  console.error(err);
                                                }
                                              }}
                                              webShowOutline={true}
                                              {...GlobalStyles.NumberInputStyles(
                                                theme
                                              )['Table Number Input'].props}
                                              placeholder={''}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.NumberInputStyles(
                                                    theme
                                                  )['Table Number Input'].style,
                                                  {
                                                    color: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: onFocusAlert
                                                        ? Constants[
                                                            'SWITCH_SCREEN_MODE'
                                                          ]
                                                          ? palettes.Brand.Black
                                                          : palettes.Brand.White
                                                        : palettes.Brand
                                                            .Transparent,
                                                    },
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 18,
                                                    },
                                                    textAlign: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'right',
                                                    },
                                                    zIndex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                              value={balanceAlert}
                                            />
                                            {/* Format View */}
                                            <>
                                              {onFocusAlert ? null : (
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'flex-end',
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 18,
                                                      },
                                                      position: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'absolute',
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                      zIndex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Format Text */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Text'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Text'].style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: Constants[
                                                              'SWITCH_SCREEN_MODE'
                                                            ]
                                                              ? palettes.Brand
                                                                  .Black
                                                              : palettes.Brand
                                                                  .White,
                                                          },
                                                          fontFamily: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              'OpenSans_600SemiBold',
                                                          },
                                                          fontSize: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 10,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {'$ '}
                                                    {formatNumber(balanceAlert)}
                                                  </Text>
                                                </View>
                                              )}
                                            </>
                                          </LinearGradient>
                                        </View>
                                      </LinearGradient>
                                    </View>
                                    {/* Right */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          backgroundColor: {
                                            minWidth: Breakpoints.Laptop,
                                            value: checkScreenMode(Variables)
                                              ? undefined
                                              : palettes.Brand.White,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Categories List */}
                                      <SimpleStyleFlatList
                                        data={usersCategories}
                                        decelerationRate={'normal'}
                                        horizontal={false}
                                        inverted={false}
                                        keyExtractor={(
                                          categoriesListData,
                                          index
                                        ) =>
                                          categoriesListData?.id ??
                                          categoriesListData?.uuid ??
                                          index?.toString() ??
                                          JSON.stringify(categoriesListData)
                                        }
                                        keyboardShouldPersistTaps={'never'}
                                        listKey={'PjlWb2DN'}
                                        nestedScrollEnabled={false}
                                        numColumns={1}
                                        onEndReachedThreshold={0.5}
                                        pagingEnabled={false}
                                        renderItem={({ item, index }) => {
                                          const categoriesListData = item;
                                          return (
                                            <>
                                              {/* Categories */}
                                              <View
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    flexDirection: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'row',
                                                    },
                                                    width: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: '100%',
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              >
                                                <LinearGradient
                                                  endY={100}
                                                  {...GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Linear Gradient'].props}
                                                  color1={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Light'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Light'
                                                    ]
                                                  }
                                                  color2={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Dark'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Dark'
                                                    ]
                                                  }
                                                  endX={0}
                                                  startX={0}
                                                  startY={0}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Linear Gradient']
                                                        .style,
                                                      {
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .Black,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              'space-between',
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              categoriesListData?.default_value ||
                                                              categoriesListData?.custom_value
                                                                ? 'flex-end'
                                                                : 'space-between',
                                                          },
                                                        ],
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        maxWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Remove Button */}
                                                  <>
                                                    {categoriesListData?.default_value ||
                                                    categoriesListData?.custom_value ? null : (
                                                      <IconButton
                                                        onPress={() => {
                                                          try {
                                                            setUsersCategories(
                                                              removeFromCategories(
                                                                usersCategories,
                                                                index
                                                              )
                                                            );
                                                            setNumberInputs(
                                                              removeFromNumberInputs(
                                                                index,
                                                                numberInputs
                                                              )
                                                            );
                                                            setTotalIncomePerMonth(
                                                              totalForMonth(
                                                                numberInputs
                                                              )
                                                            );
                                                            setTotalIncomePerCategories(
                                                              totalForCategory(
                                                                numberInputs
                                                              )
                                                            );
                                                            /* hidden 'Set Variable' action */
                                                          } catch (err) {
                                                            console.error(err);
                                                          }
                                                        }}
                                                        color={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.Brand
                                                                .White
                                                            : palettes.Brand
                                                                .Black) ??
                                                          palettes.Brand.White
                                                        }
                                                        icon={'AntDesign/minus'}
                                                        size={16}
                                                      />
                                                    )}
                                                  </>
                                                  {/* Categories Text */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                          paddingLeft: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 4,
                                                          },
                                                          paddingRight: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 4,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {categoriesListData?.custom_value ===
                                                    true
                                                      ? categoriesListData?.title
                                                      : categoriesListData
                                                          ?._income_heads
                                                          ?.title}
                                                  </Text>
                                                </LinearGradient>
                                                <SimpleStyleFlatList
                                                  data={[
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10, 11, 12,
                                                  ]}
                                                  decelerationRate={'normal'}
                                                  inverted={false}
                                                  keyExtractor={(
                                                    listData,
                                                    index
                                                  ) =>
                                                    listData?.id ??
                                                    listData?.uuid ??
                                                    index?.toString() ??
                                                    JSON.stringify(listData)
                                                  }
                                                  keyboardShouldPersistTaps={
                                                    'never'
                                                  }
                                                  listKey={JSON.stringify([
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10, 11, 12,
                                                  ])}
                                                  nestedScrollEnabled={false}
                                                  numColumns={1}
                                                  onEndReachedThreshold={0.5}
                                                  pagingEnabled={false}
                                                  renderItem={({
                                                    item,
                                                    index,
                                                  }) => {
                                                    const listData = item;
                                                    return (
                                                      <LinearGradient
                                                        endY={100}
                                                        startX={0}
                                                        startY={0}
                                                        color1={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.Brand
                                                                .Background
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]) ??
                                                          theme.colors.branding
                                                            .primary
                                                        }
                                                        color2={
                                                          (checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.App[
                                                                'Gray Linear Dark'
                                                              ]
                                                            : palettes.App[
                                                                'Light Linear - Light'
                                                              ]) ??
                                                          theme.colors.branding
                                                            .secondary
                                                        }
                                                        color3={
                                                          checkScreenMode(
                                                            Variables
                                                          )
                                                            ? palettes.Brand
                                                                .Background
                                                            : palettes.App[
                                                                'Light Linear - Dark'
                                                              ]
                                                        }
                                                        endX={0}
                                                        style={StyleSheet.applyWidth(
                                                          {
                                                            borderBottomWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderRightWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'center',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            width: [
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value: null,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              {
                                                                minWidth:
                                                                  Breakpoints.BigScreen,
                                                                value:
                                                                  (dimensions.width -
                                                                    dimensions.width *
                                                                      (15 /
                                                                        100) -
                                                                    600) /
                                                                  14,
                                                              },
                                                            ],
                                                          },
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {/* Matrix Input */}
                                                        <NumberInput
                                                          changeTextDelay={500}
                                                          onBlur={() => {
                                                            try {
                                                              setSelectedIndexes(
                                                                addOrRemove(
                                                                  selectedIndexes,
                                                                  index,
                                                                  findIndextAllCategories(
                                                                    sortCategories(
                                                                      usersCategories
                                                                    ),
                                                                    categoriesListData
                                                                  )
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onChangeText={newMatrixInputValue => {
                                                            try {
                                                              /* hidden 'Log to Console' action */
                                                              const initData =
                                                                updateTableRows(
                                                                  index,
                                                                  findIndextAllCategories(
                                                                    usersCategories,
                                                                    categoriesListData
                                                                  ),
                                                                  newMatrixInputValue >=
                                                                    0
                                                                    ? newMatrixInputValue
                                                                    : 0,
                                                                  numberInputs
                                                                );
                                                              setTotalIncomePerCategories(
                                                                totalForCategory(
                                                                  numberInputs
                                                                )
                                                              );

                                                              const valueGPndN2qa =
                                                                totalForMonth(
                                                                  numberInputs
                                                                );
                                                              const total_per_month =
                                                                valueGPndN2qa;
                                                              setTotalIncomePerMonth(
                                                                valueGPndN2qa
                                                              );
                                                              /* hidden 'Set Variable' action */
                                                              /* hidden 'Set Variable' action */

                                                              const value8bzr5Mas =
                                                                updateStartingBalanceWithIncomeChange(
                                                                  monthlyStartingBalance,
                                                                  totalIncomePerMonth.slice(
                                                                    0,
                                                                    12
                                                                  ),
                                                                  total_per_month.slice(
                                                                    0,
                                                                    12
                                                                  )
                                                                );
                                                              const new_monthly =
                                                                value8bzr5Mas;
                                                              setMonthlyStartingBalance(
                                                                value8bzr5Mas
                                                              );
                                                              setTotalCashAvailablePerMonth(
                                                                sumArrays(
                                                                  new_monthly,
                                                                  total_per_month
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          onFocus={() => {
                                                            try {
                                                              setSelectedIndexes(
                                                                addOrRemove(
                                                                  selectedIndexes,
                                                                  index,
                                                                  findIndextAllCategories(
                                                                    sortCategories(
                                                                      usersCategories
                                                                    ),
                                                                    categoriesListData
                                                                  )
                                                                )
                                                              );
                                                            } catch (err) {
                                                              console.error(
                                                                err
                                                              );
                                                            }
                                                          }}
                                                          {...GlobalStyles.NumberInputStyles(
                                                            theme
                                                          )[
                                                            'Table Number Input'
                                                          ].props}
                                                          defaultValue={getInitValue(
                                                            numberInputs,
                                                            findIndextAllCategories(
                                                              usersCategories,
                                                              categoriesListData
                                                            ),
                                                            index
                                                          )}
                                                          placeholder={''}
                                                          style={StyleSheet.applyWidth(
                                                            StyleSheet.compose(
                                                              GlobalStyles.NumberInputStyles(
                                                                theme
                                                              )[
                                                                'Table Number Input'
                                                              ].style,
                                                              {
                                                                color: [
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'rgba(0, 0, 0, 0)',
                                                                  },
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      selectedIndexes.includes(
                                                                        findColumnRowNumber(
                                                                          index,
                                                                          findIndextAllCategories(
                                                                            sortCategories(
                                                                              usersCategories
                                                                            ),
                                                                            categoriesListData
                                                                          )
                                                                        )
                                                                      )
                                                                        ? Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White
                                                                        : palettes
                                                                            .Brand
                                                                            .Transparent,
                                                                  },
                                                                ],
                                                                textAlign: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'right',
                                                                },
                                                                zIndex: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              }
                                                            ),
                                                            dimensions.width
                                                          )}
                                                          webShowOutline={false}
                                                        />
                                                        {/* Format View */}
                                                        <>
                                                          {selectedIndexes.includes(
                                                            findColumnRowNumber(
                                                              index,
                                                              findIndextAllCategories(
                                                                sortCategories(
                                                                  usersCategories
                                                                ),
                                                                categoriesListData
                                                              )
                                                            )
                                                          ) ? null : (
                                                            <View
                                                              style={StyleSheet.applyWidth(
                                                                {
                                                                  alignItems: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                  flexDirection:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'row',
                                                                    },
                                                                  justifyContent:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        'space-between',
                                                                    },
                                                                  paddingLeft: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 4,
                                                                  },
                                                                  paddingRight:
                                                                    {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value: 4,
                                                                    },
                                                                  position: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'absolute',
                                                                  },
                                                                  width: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      '100%',
                                                                  },
                                                                  zIndex: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 0,
                                                                  },
                                                                },
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {/* $ */}
                                                              <Text
                                                                accessible={
                                                                  true
                                                                }
                                                                selectable={
                                                                  false
                                                                }
                                                                {...GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].props}
                                                                style={StyleSheet.applyWidth(
                                                                  StyleSheet.compose(
                                                                    GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .style,
                                                                    {
                                                                      color: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                            ? palettes
                                                                                .Brand
                                                                                .Black
                                                                            : palettes
                                                                                .Brand
                                                                                .White,
                                                                      },
                                                                      fontFamily:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'OpenSans_600SemiBold',
                                                                        },
                                                                      fontSize:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 10,
                                                                        },
                                                                    }
                                                                  ),
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {'$'}
                                                              </Text>
                                                              {/* Number Value */}
                                                              <Text
                                                                accessible={
                                                                  true
                                                                }
                                                                selectable={
                                                                  false
                                                                }
                                                                {...GlobalStyles.TextStyles(
                                                                  theme
                                                                )['Text'].props}
                                                                style={StyleSheet.applyWidth(
                                                                  StyleSheet.compose(
                                                                    GlobalStyles.TextStyles(
                                                                      theme
                                                                    )['Text']
                                                                      .style,
                                                                    {
                                                                      color: {
                                                                        minWidth:
                                                                          Breakpoints.Laptop,
                                                                        value:
                                                                          Constants[
                                                                            'SWITCH_SCREEN_MODE'
                                                                          ]
                                                                            ? palettes
                                                                                .Brand
                                                                                .Black
                                                                            : palettes
                                                                                .Brand
                                                                                .White,
                                                                      },
                                                                      fontFamily:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value:
                                                                            'OpenSans_600SemiBold',
                                                                        },
                                                                      fontSize:
                                                                        {
                                                                          minWidth:
                                                                            Breakpoints.Laptop,
                                                                          value: 10,
                                                                        },
                                                                    }
                                                                  ),
                                                                  dimensions.width
                                                                )}
                                                              >
                                                                {formatNumber(
                                                                  getInitValue(
                                                                    numberInputs,
                                                                    findIndextAllCategories(
                                                                      usersCategories,
                                                                      categoriesListData
                                                                    ),
                                                                    index
                                                                  )
                                                                )}
                                                              </Text>
                                                            </View>
                                                          )}
                                                        </>
                                                      </LinearGradient>
                                                    );
                                                  }}
                                                  showsHorizontalScrollIndicator={
                                                    true
                                                  }
                                                  showsVerticalScrollIndicator={
                                                    true
                                                  }
                                                  snapToAlignment={'start'}
                                                  extraData={reRender}
                                                  horizontal={true}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                />
                                              </View>
                                            </>
                                          );
                                        }}
                                        showsHorizontalScrollIndicator={true}
                                        showsVerticalScrollIndicator={true}
                                        snapToAlignment={'start'}
                                        extraData={reRender}
                                        style={StyleSheet.applyWidth(
                                          {
                                            flex: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      />
                                      {/* Additional Categories */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            maxHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            minHeight: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Gray Linear Gradient */}
                                        <LinearGradient
                                          endY={100}
                                          color1={
                                            (checkScreenMode(Variables)
                                              ? palettes.App[
                                                  'Gray Linear Light'
                                                ]
                                              : palettes.App[
                                                  'Light Linear - Light'
                                                ]) ??
                                            palettes.App['Gray Linear Light']
                                          }
                                          color2={
                                            (checkScreenMode(Variables)
                                              ? palettes.App['Gray Linear Dark']
                                              : palettes.App[
                                                  'Light Linear - Dark'
                                                ]) ??
                                            palettes.App['Gray Linear Dark']
                                          }
                                          endX={0}
                                          startX={0}
                                          startY={0}
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 'stretch',
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'stretch',
                                                },
                                              ],
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.Black,
                                              },
                                              borderLeftWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              borderRightWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'center',
                                              },
                                              maxHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              maxWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              minHeight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              minWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              width: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Remove Button */}
                                          <>
                                            {!toggleAddCategory ? null : (
                                              <IconButton
                                                onPress={() => {
                                                  try {
                                                    setToggleAddCategory(false);
                                                    setToggleNewCategory(false);
                                                    setNewCategory('');
                                                  } catch (err) {
                                                    console.error(err);
                                                  }
                                                }}
                                                color={
                                                  (checkScreenMode(Variables)
                                                    ? palettes.Brand.White
                                                    : palettes.Brand.Black) ??
                                                  palettes.Brand.White
                                                }
                                                icon={'AntDesign/minus'}
                                                size={16}
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    left: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 0,
                                                    },
                                                    position: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'absolute',
                                                    },
                                                    zIndex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 100,
                                                    },
                                                  },
                                                  dimensions.width
                                                )}
                                              />
                                            )}
                                          </>
                                          <>
                                            {!(
                                              toggleAddCategory &&
                                              !toggleNewCategory
                                            ) ? null : (
                                              <Utils.CustomCodeErrorBoundary>
                                                <AdditionalCategory.Dropdown
                                                  allCategories={allCategories}
                                                  setToggleAddCategory={
                                                    setToggleAddCategory
                                                  }
                                                  numberInputs={numberInputs}
                                                  setNumberInputs={
                                                    setNumberInputs
                                                  }
                                                  numberInputs={numberInputs}
                                                  totalIncomePerCategories={
                                                    totalIncomePerCategories
                                                  }
                                                  setTotalIncomePerCategories={
                                                    setTotalIncomePerCategories
                                                  }
                                                  setToggleNewCategory={
                                                    setToggleNewCategory
                                                  }
                                                  sliceValue={8}
                                                  usersCategories={
                                                    usersCategories
                                                  }
                                                  setUsersCategories={
                                                    setUsersCategories
                                                  }
                                                  headType={'_income_heads'}
                                                />
                                              </Utils.CustomCodeErrorBoundary>
                                            )}
                                          </>
                                          <>
                                            {toggleAddCategory ||
                                            toggleNewCategory ? null : (
                                              <Button
                                                accessible={true}
                                                iconPosition={'left'}
                                                onPress={() => {
                                                  try {
                                                    setToggleAddCategory(true);
                                                  } catch (err) {
                                                    console.error(err);
                                                  }
                                                }}
                                                {...GlobalStyles.ButtonStyles(
                                                  theme
                                                )['Button'].props}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.ButtonStyles(
                                                      theme
                                                    )['Button'].style,
                                                    {
                                                      backgroundColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          'rgba(0, 0, 0, 0)',
                                                      },
                                                      color: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.Brand.White
                                                          : palettes.Brand
                                                              .Black,
                                                      },
                                                      fontFamily: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'System',
                                                      },
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 16,
                                                      },
                                                      fontWeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '600',
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                                title={'+'}
                                              />
                                            )}
                                          </>
                                          {/* Custom Category Input */}
                                          <>
                                            {!toggleNewCategory ? null : (
                                              <TextInput
                                                autoCapitalize={'none'}
                                                autoCorrect={true}
                                                changeTextDelay={500}
                                                onChangeText={newCustomCategoryInputValue => {
                                                  try {
                                                    setNewCategory(
                                                      newCustomCategoryInputValue
                                                    );
                                                  } catch (err) {
                                                    console.error(err);
                                                  }
                                                }}
                                                onSubmitEditing={() => {
                                                  try {
                                                    setUsersCategories(
                                                      customCategory(
                                                        usersCategories,
                                                        newCategory
                                                      )
                                                    );
                                                    /* hidden 'Set Variable' action */
                                                    setNumberInputs(
                                                      addNewRow(numberInputs)
                                                    );
                                                    setToggleNewCategory(false);
                                                    setToggleAddCategory(false);
                                                    setTotalIncomePerCategories(
                                                      totalForCategory(
                                                        numberInputs
                                                      )
                                                    );
                                                    setNewCategory('');
                                                  } catch (err) {
                                                    console.error(err);
                                                  }
                                                }}
                                                webShowOutline={true}
                                                {...GlobalStyles.TextInputStyles(
                                                  theme
                                                )['Text Input'].props}
                                                autoFocus={true}
                                                placeholder={
                                                  'Enter New Category'
                                                }
                                                placeholderTextColor={
                                                  (checkScreenMode(Variables)
                                                    ? palettes.Brand.White
                                                    : palettes.Brand.Black) ??
                                                  palettes.Brand.White
                                                }
                                                selectionColor={
                                                  'rgba(0, 0, 0, 0)'
                                                }
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.TextInputStyles(
                                                      theme
                                                    )['Text Input'].style,
                                                    {
                                                      backgroundColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          'rgba(0, 0, 0, 0)',
                                                      },
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      borderLeftWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      borderRadius: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      borderTopWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      color: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .White,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      ],
                                                      fontFamily: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          'OpenSans_600SemiBold',
                                                      },
                                                      fontSize: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 10,
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      paddingRight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 4,
                                                      },
                                                      textAlign: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'right',
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                                value={newCategory}
                                              />
                                            )}
                                          </>
                                        </LinearGradient>
                                      </View>
                                      {/* Bottom Total */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.Black,
                                            },
                                            borderLeftWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            borderTopWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            bottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 50,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Total Income */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderBottomWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Income'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total Income */}
                                          <SimpleStyleFlatList
                                            data={totalIncomePerMonth.concat([
                                              '100.00%',
                                            ])}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalIncomeData,
                                              index
                                            ) =>
                                              totalIncomeData?.id ??
                                              totalIncomeData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(totalIncomeData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'KaYDTXQk'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalIncomeData = item;
                                              return (
                                                <>
                                                  {/* Total Income */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderBottomWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderLeftWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* $ */}
                                                    <>
                                                      {!(index < 13) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$'}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* Total Income */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].props}
                                                      style={StyleSheet.applyWidth(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].style,
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {index < 13
                                                        ? formatNumber(
                                                            totalIncomeData
                                                          )
                                                        : totalIncomeData}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            extraData={reRender}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                        {/* Total Cash Available */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Linear Gradient 2 */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Cash Available'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total Cash Available */}
                                          <SimpleStyleFlatList
                                            data={totalCashAvailablePerMonth.concat(
                                              ['', '']
                                            )}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalCashAvailableData,
                                              index
                                            ) =>
                                              totalCashAvailableData?.id ??
                                              totalCashAvailableData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                totalCashAvailableData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'LOWpLwel'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalCashAvailableData =
                                                item;
                                              return (
                                                <>
                                                  {/* Total Income */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderLeftWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: [
                                                            {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 75,
                                                            },
                                                            {
                                                              minWidth:
                                                                Breakpoints.BigScreen,
                                                              value:
                                                                cellWidth(),
                                                            },
                                                          ],
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Cash Available Item */}
                                                    <>
                                                      {!(index <= 11) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            totalCashAvailableData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                      </View>
                                    </View>
                                    {/* Total/Benchmarks */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          flexDirection: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'row',
                                          },
                                          position: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'absolute',
                                          },
                                          right: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 0,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      <SimpleStyleFlatList
                                        data={totalIncomePerCategories}
                                        decelerationRate={'normal'}
                                        horizontal={false}
                                        inverted={false}
                                        keyExtractor={(listData, index) =>
                                          listData?.id ??
                                          listData?.uuid ??
                                          index?.toString() ??
                                          JSON.stringify(listData)
                                        }
                                        keyboardShouldPersistTaps={'never'}
                                        listKey={'qGJTlhK3'}
                                        nestedScrollEnabled={false}
                                        numColumns={1}
                                        onEndReachedThreshold={0.5}
                                        pagingEnabled={false}
                                        renderItem={({ item, index }) => {
                                          const listData = item;
                                          return (
                                            <>
                                              {/* Total Gradiant */}
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Category Gradient'].props}
                                                color1={
                                                  checkScreenMode(Variables)
                                                    ? palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    : palettes.App[
                                                        'Light Linear - Light'
                                                      ]
                                                }
                                                color2={
                                                  checkScreenMode(Variables)
                                                    ? palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    : palettes.App[
                                                        'Light Linear - Dark'
                                                      ]
                                                }
                                                color3={null}
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Category Gradient']
                                                      .style,
                                                    {
                                                      flex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: null,
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: cellWidth(),
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {/* Total Value */}
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text White'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .style,
                                                      {
                                                        color: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {'$ '}
                                                  {totalIncomePerCategories?.length >=
                                                  1
                                                    ? formatNumber(listData)
                                                    : formatNumber(0)}
                                                </Text>
                                              </LinearGradient>
                                            </>
                                          );
                                        }}
                                        showsHorizontalScrollIndicator={true}
                                        showsVerticalScrollIndicator={true}
                                        snapToAlignment={'start'}
                                        extraData={reRender}
                                      />
                                      {/* List 2 */}
                                      <SimpleStyleFlatList
                                        data={calculateBenchmark(
                                          totalIncomePerCategories
                                        )}
                                        decelerationRate={'normal'}
                                        horizontal={false}
                                        inverted={false}
                                        keyExtractor={(list2Data, index) =>
                                          list2Data?.id ??
                                          list2Data?.uuid ??
                                          index?.toString() ??
                                          JSON.stringify(list2Data)
                                        }
                                        keyboardShouldPersistTaps={'never'}
                                        listKey={'fbhdvLsf'}
                                        nestedScrollEnabled={false}
                                        numColumns={1}
                                        onEndReachedThreshold={0.5}
                                        pagingEnabled={false}
                                        renderItem={({ item, index }) => {
                                          const list2Data = item;
                                          return (
                                            <>
                                              {/* Benchmarks */}
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                color1={
                                                  (checkScreenMode(Variables)
                                                    ? palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    : palettes.App[
                                                        'Light Linear - Light'
                                                      ]) ??
                                                  palettes.App[
                                                    'Gray Linear Light'
                                                  ]
                                                }
                                                color2={
                                                  (checkScreenMode(Variables)
                                                    ? palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    : palettes.App[
                                                        'Light Linear - Dark'
                                                      ]) ??
                                                  palettes.App[
                                                    'Gray Linear Dark'
                                                  ]
                                                }
                                                color3={null}
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  {
                                                    alignItems: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'center',
                                                    },
                                                    borderBottomWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 1,
                                                    },
                                                    flex: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: null,
                                                    },
                                                    height: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 25,
                                                    },
                                                    justifyContent: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 'center',
                                                    },
                                                    maxHeight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 25,
                                                    },
                                                    minHeight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 25,
                                                    },
                                                    minWidth: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 75,
                                                    },
                                                    width: [
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: null,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: cellWidth(),
                                                      },
                                                    ],
                                                  },
                                                  dimensions.width
                                                )}
                                              >
                                                {/* Benchmarks */}
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text White'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .style,
                                                      {
                                                        color: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .White
                                                              : palettes.Brand
                                                                  .Black,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {formatPercentage(list2Data)}
                                                </Text>
                                              </LinearGradient>
                                            </>
                                          );
                                        }}
                                        showsHorizontalScrollIndicator={true}
                                        showsVerticalScrollIndicator={true}
                                        snapToAlignment={'start'}
                                        extraData={reRender}
                                      />
                                    </View>
                                  </View>
                                </View>
                              </SimpleStyleScrollView>
                            )}
                          </>
                          {/* Button View */}
                          <>
                            {isLoading ? null : (
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    paddingBottom: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 24,
                                    },
                                    paddingRight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 24,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Button
                                  accessible={true}
                                  iconPosition={'left'}
                                  onPress={() => {
                                    const handler = async () => {
                                      try {
                                        setIsLoading(true);
                                        setIsFetching(true);
                                        setGlobalVariableValue({
                                          key: 'STARTING_CASH',
                                          value: startingCashOn,
                                        });
                                        const newStartingDate =
                                          setGlobalVariableValue({
                                            key: 'STARTING_DATE',
                                            value: newFormatDate(
                                              startingDate,
                                              'get'
                                            ),
                                          });
                                        setGlobalVariableValue({
                                          key: 'BALANCE_ALERT',
                                          value: balanceAlert,
                                        });
                                        const forData = mergeCategoriesNumbers(
                                          usersCategories,
                                          numberInputs,
                                          newStartingDate
                                        );
                                        const test = (
                                          await defaultPostIncomesPOST.mutateAsync(
                                            {
                                              cash: startingCashOn,
                                              cash_min_balance: balanceAlert,
                                              incomes: forData,
                                              start_month: newStartingDate,
                                              starting_cash_values:
                                                createStartingBalance(
                                                  startingDate,
                                                  monthlyStartingBalance
                                                ),
                                            }
                                          )
                                        )?.json;
                                        setReFetch(false);
                                        setIsFetching(false);
                                        /* hidden 'Set Variable' action */
                                        setTrigger(!trigger);
                                      } catch (err) {
                                        console.error(err);
                                      }
                                    };
                                    handler();
                                  }}
                                  {...GlobalStyles.ButtonStyles(theme)[
                                    'Submit Button'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    GlobalStyles.ButtonStyles(theme)[
                                      'Submit Button'
                                    ].style,
                                    dimensions.width
                                  )}
                                  title={'Submit'}
                                />
                              </View>
                            )}
                          </>
                        </>
                      );
                    }}
                  </DefaultApi.FetchGetIncomeHeadsGET>
                )}
              </>
            </View>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(IncomeFormScreen);
